var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6226_7213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3327 10.6066C19.8255 7.09933 14.112 7.09933 10.6048 10.6066C7.09754 14.1138 7.09754 19.8272 10.6048 23.3345C14.112 26.8417 19.8255 26.8417 23.3327 23.3345C26.84 19.8272 26.84 14.1138 23.3327 10.6066ZM11.4745 22.4648C8.44104 19.4313 8.44811 14.5027 11.4745 11.4763C14.5009 8.4499 19.4366 8.4499 22.463 11.4763C25.4894 14.5027 25.4894 19.4383 22.463 22.4648C19.4366 25.4912 14.5009 25.4912 11.4745 22.4648Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5381 16.9705C21.5381 16.6453 21.2481 16.3554 20.9229 16.3554L17.5853 16.3554V13.0178C17.5853 12.6926 17.2954 12.4026 16.9701 12.4026C16.6307 12.4026 16.355 12.6784 16.355 13.0178L16.355 16.3554L13.0174 16.3554C12.678 16.3554 12.4022 16.6311 12.4022 16.9705C12.4022 17.2958 12.6922 17.5857 13.0174 17.5857L16.355 17.5857L16.355 20.9233C16.355 21.093 16.4186 21.2415 16.5317 21.3546C16.6449 21.4677 16.8004 21.5385 16.9631 21.5314C17.3025 21.5314 17.5783 21.2556 17.5783 20.9162L17.5783 17.5787L20.9158 17.5787C21.2552 17.5787 21.531 17.3029 21.531 16.9635L21.5381 16.9705Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6226_7213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.9688) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusRound);
export default __webpack_public_path__ + "static/media/iconPlusRound.d34a4cf06c77955bdc3273af87602c16.svg";
export { ForwardRef as ReactComponent };